import DeleteAlert from "../../../components/DeleteAlert";
import { useLanguage } from "../../../contexts/LanguageContext";
import { disconnectLines, providerByKey } from "../providers";
import { ErrorBox } from "./ui";

// Confirms a disconnect and says what it deletes, on the shared DeleteAlert.
// It opens over the drawer (hence the z-index) and, while the request runs,
// cannot be dismissed. A failed disconnect keeps it open with the API's reason.
export default function DisconnectDialog({ open, integration, onClose, onConfirm, isPending, errorLines }) {
  const { t } = useLanguage();
  const name = providerByKey(integration?.integration_type)?.name || "";
  const lines = integration ? disconnectLines(integration, t) : [];

  return (
    <DeleteAlert
      isOpen={open}
      onClose={onClose}
      onConfirm={onConfirm}
      role="alertdialog"
      zIndexClassName="z-92147483004"
      title="integrations.disconnectDialog.title"
      titleValues={{ name }}
      description={null}
      buttonText="integrations.disconnectDialog.confirm"
      buttonTextValues={{ name }}
      loadingText="integrations.disconnectDialog.disconnecting"
      isLoading={isPending}
    >
      <ul className="flex list-disc flex-col gap-1.5 pl-[18px] text-sm leading-normal text-gray-700">
        {lines.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
      {errorLines?.length > 0 && (
        <div className="mt-3">
          <ErrorBox lines={errorLines} />
        </div>
      )}
    </DeleteAlert>
  );
}
